import { render, staticRenderFns } from "./detailStyle.vue?vue&type=template&id=7dc80be8"
import script from "./detailStyle.vue?vue&type=script&lang=js"
export * from "./detailStyle.vue?vue&type=script&lang=js"
import style0 from "./detailStyle.vue?vue&type=style&index=0&id=7dc80be8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports